import { iPortInfo } from './data/iport'
import { JsonLD } from './JsonLD'

export const jsonLD = new JsonLD(iPortInfo)
